import React from 'react';
import ErrorDiv from "root/ReactHookForm/FormComponents/ErrorDiv";
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import FieldsetContainer from "root/Base/FieldsetContainer";
import {UserTypes} from "root/DataFunctions/Constants";
import DropdownUsers from "root/ReactHookForm/ui/DropdownUsers";

const HookSubFormIRO = ({control, register, watch, formErrors, sectionName, readOnly}) =>
{
    const validateCarer = (val) =>
    {
    }

    return (
        <FieldsetContainer title='Independent Reviewing Officer' noborder={true}>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <div style={{marginTop: '10px', fontStyle: 'italic', color: 'var(--s360-icon-blue)'}}>If you know which the pupil's Independent Reviewing Officer is, you can select them at this point.</div>
                </BootstrapCol>
            </BootstrapRow>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <label className='col-form-label'>Select an Independent Reviewing Officer (Use the filter to narrow down the list)</label>
                    <DropdownUsers name={sectionName + '.iro_id'} user_type={UserTypes.IRO} isClearable={true} control={control} rules={{validate: validateCarer}}
                                                      placeHolder='Pick an Independent Reviewing Officer' readOnly={readOnly} isSearchable={true}/>
                    {formErrors[sectionName]?.iro_id?.type === 'validate' && <ErrorDiv>Please select a reviewing officer</ErrorDiv>}

                </BootstrapCol>
            </BootstrapRow>

        </FieldsetContainer>
    )
}

export default HookSubFormIRO;
